import React from "react";
import { Box, Skeleton } from "@mui/material";

const SerivceTabsSkeleton = () => {
  return (
    <Box
      sx={{
        width: "95%",
        margin: "0px auto",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        gap: 4,
        overflow: "hidden",
      }}
    >
      {[...Array(10)].map((_, index) => (
        <Box
          key={index}
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            gap: 1,
          }}
        >
          <Skeleton
            variant="circular"
            width={40}
            height={40}
            animation="wave"
          />
          <Skeleton
            variant="text"
            width={60}
            height={12}
            animation="wave"
          />
        </Box>
      ))}
    </Box>
  );
};

export default SerivceTabsSkeleton;
